import React from "react";
import JsonLd from "./JsonLd";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://testimonialshub.com";

export default function HomeSchema() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "TestimonialsHub",
    url: SITE_URL,
    logo: `${SITE_URL}/brand/logo.png`,
  };

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "TestimonialsHub",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: SITE_URL,
    description:
      "TestimonialsHub helps businesses collect, manage, and display text and video testimonials with Wall of Love widgets.",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
    publisher: {
      "@type": "Organization",
      name: "TestimonialsHub",
      url: SITE_URL,
    },
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "TestimonialsHub",
    url: SITE_URL,
  };

  return (
    <>
      <JsonLd data={organizationSchema} />
      <JsonLd data={softwareSchema} />
      <JsonLd data={websiteSchema} />
    </>
  );
}
